// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"FetchListing_pageWrapper__2R8Dh","error":"FetchListing_error__10PO7","loading":"FetchListing_loading__2HnYK"};